module.exports = __webpack_public_path__ + "img/modal-el-lock.306a3f8f.svg";